import { Inject, Injectable, isDevMode } from '@angular/core';
import { ISplugDefinitionDto } from 'core/dto';
import { ObjectUtils } from 'core/utils';
import { BehaviorSubject } from 'rxjs';
import { ISupportedLanguage } from './types';
import { SS_VERSION } from './version';


export type LBatchSigning = 'none' | 'all' | 'custom'
export type LProcessSharing = 'creatorSigners' | 'creatorSignersTeams'
export type LSigningOrderType = 'paralel' | 'serial' | 'custom'


export interface IAppConfig {

  language: {
    defaultLanguage: string
    supportedLanguages: ISupportedLanguage[]
  },
  designerLogin: 'userPassword' | 'oidc' | 'sso'

  sessionTimeout: number,
  activityOpenPosition: 'documentTop' | 'firstTask',
  batchSigningDefault: LBatchSigning,
  processSharingDefault: LProcessSharing,
  signingOrderTypeDefault: LSigningOrderType,
  processExpirationInDaysDefault: number,
  api: {
    url: string,
    contextRoot: string
  }
}


@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  appConfig: IAppConfig;

  private readonly configProdPath = 'assets/config/config.prod.json'
  private readonly configDevPath = 'assets/config/config.dev.json'
  private readonly translationsPath = 'assets/i18n';

  private readonly splugDefinitionsSubject = new BehaviorSubject<ISplugDefinitionDto>(undefined)
  set splugDefinitions(value: ISplugDefinitionDto) {
    this.splugDefinitionsSubject.next(value);
  }

  get configPath() {

    if (isDevMode()) {
      return this.configDevPath;
    }

    return this.configProdPath;
  }

  constructor(
    @Inject(SS_VERSION)
    private readonly _version: string
  ) {
  }

  async load() {

    const data = await fetch(this.configPath + '?version=' + this._version, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    })

    const appConfig = await data.json();

    this.appConfig = appConfig;


    this.testTranslations();
  }


  testTranslations() {

    if (!isDevMode()) {
      return;
    }

    Promise.all(
      this.appConfig.language.supportedLanguages
        .map(({ key }) => key)
        .map((key) => fetch(this.translationsPath + '/' + key + '.json', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(resp => resp.json())
        )
    )
      .then((translations) => {
        const translationComparsions = ObjectUtils.deepCompareObjectKeys(translations);
      })

  }
}
